import { useState, useEffect, useContext } from 'react';
import { AppContext } from '../context/context'
import BrandAdd from '../features/brand/brand_add';
import UiButton1 from './ui_button1';
import BrandEdit from '../features/brand/brand_edit';
import UiPopupSidebarDeleteMarketplace from '../features/brand/delete_marketplace';
import UiPopupSidebarDeleteProfile from '../features/brand/delete_profile';
import UiPopupSidebarUnsubscribe from '../features/subscription/unsubscribe';
import NavbarSidebar from '../layout/navbar_sidebar';
import ConfirmChangeEmail from '../features/account/confirm_change_email';
import UserAdd from '../features/user/user_add';
import UserEdit from '../features/user/user_edit';
import UserDelete from '../features/user/user_delete';
import EditorExport from '../features/editor/editor_export';
import EditorImport from '../features/editor/editor_import';
import BrandGoalsDeleteYear from '../features/brand/brand_goals_delete_year';

const UiPopupSidebar = () => {

	const {
		popupSidebarType,
		setPopupSidebarType,
		setShowCanvas,
		sidebarTitle,
		editBrandId,
		getBrands,
		ww,
		offCanvas,
		fetchDataV2
	} = useContext(AppContext)

	const [loading, setLoading] = useState(false)

	const closeSidebar = () => {
		setPopupSidebarType("")
		setShowCanvas(false)
		offCanvas.hide()
	}

	const brandStatusChangeHandler = async (active) => {
		setLoading(true)

		let query1 = "UPDATE_BRAND_STATUS", params1 = [active, editBrandId]

		try {
			await fetchDataV2(query1, params1, "/neon-query-v2")
		}
		catch (err) {
			setLoading(false)
			return
		}

		await getBrands()
		offCanvas.hide()
		setLoading(false)
	}

	useEffect(() => {
		if (ww >= 800 && popupSidebarType == 'sidebar' && offCanvas) {
			offCanvas.hide()
			setPopupSidebarType("")
		}
	}, [ww])

	return (
		<div>
			<div style={{ minWidth: ww < 450 ? ww : 450 }} className={"offcanvas " + (popupSidebarType == 'sidebar' ? ' offcanvas-start' : ' offcanvas-end')} tabIndex="-1" id="offcanvasRight" aria-labelledby="offcanvasRightLabel">
				<div hidden={popupSidebarType == "sidebar"} className="offcanvas-header px-4 mb-0">
					<h5 className="offcanvas-title fs-3" id="offcanvasRightLabel">{sidebarTitle || "Sidebar"}</h5>
					<button onClick={closeSidebar} type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
				</div>
				<div hidden={popupSidebarType == "sidebar"} style={{ height: 2 }} className="gradiant-h mb-4 mx-4"></div>
				<div className={"offcanvas-body p-0 " + (popupSidebarType == "sidebar" ? "" : "px-4 pb-4")}>
					{popupSidebarType == 'add_brand' ?
						<BrandAdd />
						:
						popupSidebarType == 'edit_brand' ?
							<BrandEdit />
							:
							popupSidebarType == 'off_brand' ?
								<div className="h-100" style={{ overflow: "hidden" }}>
									{!loading ?
										<div className="h-100 d-flex flex-column justify-content-between">
											<div>
												<p className="poppins">Are you sure you want to deactivate this account?</p>
											</div>
											<UiButton1 text="Deactivate" submit={() => brandStatusChangeHandler(false)} />
										</div>
										: <p className="poppins">loading...</p>
									}
								</div>
								:
								popupSidebarType == 'on_brand' ?
									<div className="h-100" style={{ overflow: "hidden" }}>
										{!loading ?
											<div className="h-100 d-flex flex-column justify-content-between">
												<div>
													<p className="poppins">Activate this Account?</p>
												</div>
												<UiButton1 text="Activate" submit={() => brandStatusChangeHandler(true)} />
											</div>
											: <p className="poppins">loading...</p>
										}
									</div>
									:
									popupSidebarType == 'delete_marketplace' ?
										<UiPopupSidebarDeleteMarketplace closeSidebar={closeSidebar} />
										:
										popupSidebarType == 'delete_profile' ?
											<UiPopupSidebarDeleteProfile closeSidebar={closeSidebar} />
											:
											popupSidebarType == 'unsubscribe' ?
												<UiPopupSidebarUnsubscribe />
												:
												popupSidebarType == 'sidebar' ?
													<NavbarSidebar showClose={true} />
													:
													popupSidebarType == 'change_email' ?
														<ConfirmChangeEmail />
														:
														popupSidebarType == 'user_add' ?
															<UserAdd />
															:
															popupSidebarType == 'user_edit' ?
																<UserEdit />
																:
																popupSidebarType == 'user_delete' ?
																	<UserDelete />
																	:
																	popupSidebarType == 'exp_imp' ?
																		<div className='d-flex flex-column gap-5'>
																			<EditorExport />
																			<EditorImport />
																		</div>
																		:
																		popupSidebarType == 'delete_year_marketplace' ?
																			<BrandGoalsDeleteYear />
																			:
																			null
					}
				</div>
			</div>
		</div>
	)
}

export default UiPopupSidebar